import { Container, IDestroyOptions, Point } from "pixi.js";
import { MyWalletPanelElement } from "./MyWalletPanelElement";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { Event } from "event-system";
import { WalletTabType } from "../WalletTabType";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";

export class MyWalletTabsPanel extends Container {
    private static readonly panelElementsInitialPosition: Map<WalletTabType, Point> = new Map([
        [WalletTabType.PIGGY_CLUB, new Point(28, 0)],
        [WalletTabType.BUILDING, new Point(208, 0)],
        [WalletTabType.DICE_ROLLS, new Point(388, 0)],
        [WalletTabType.TOKENS, new Point(568, 0)],
    ]);

    public readonly onSwitchTab: Event<WalletTabType>;

    private readonly panelElements: Map<WalletTabType, MyWalletPanelElement>;

    private currentTabType: WalletTabType;

    public constructor(
        myWalletResources: MyWalletResourcePackage,
        commonResources: CommonResourcesPackage,
        currentTabType: WalletTabType
    ) {
        super();
        this.currentTabType = currentTabType;
        this.onSwitchTab = new Event();
        this.panelElements = new Map(
            Array.from(MyWalletTabsPanel.panelElementsInitialPosition.keys()).map((tabState) => {
                const position = MyWalletTabsPanel.panelElementsInitialPosition.get(tabState)
                const panelElement = new MyWalletPanelElement(myWalletResources, commonResources, tabState, position);
                panelElement.position.copyFrom(position);
                return [tabState, panelElement];
            })
        );
        this.panelElements.forEach((panelElement) => {
            this.addChild(panelElement);
            panelElement.onClick.add(this.onTabClickHandle, this)
        });
        this.panelElements.get(this.currentTabType).selected = true;
    }

    private onTabClickHandle(tabType: WalletTabType): void {
        if (tabType === this.currentTabType) {
            return;
        }
        this.panelElements.get(this.currentTabType).selected = false;
        this.panelElements.get(tabType).selected = true;
        this.currentTabType = tabType;
        this.onSwitchTab.emit(tabType);
    }

    public setPointerToPanelElement(tab: WalletTabType, withPointer: boolean): void {
        this.panelElements.get(tab).withPointer = withPointer;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.panelElements.forEach((panelElement) => panelElement.onClick.remove(this.onTabClickHandle, this));
        super.destroy(options);
    }
}
